/**
 * Twilio webchat widget stores JSON under `localStorage`; parse `conversationSid` for Redux/CDP.
 */
export function parseConversationSidFromLocalStorage(raw: string | null): string | null {
  if (raw === null || raw === '') return null;
  try {
    const parsed = JSON.parse(raw) as { conversationSid?: unknown };
    const sid = parsed?.conversationSid;
    return typeof sid === 'string' && sid.length > 0 ? sid : null;
  } catch {
    return null;
  }
}
